import request from "@/utils/request";
import * as type from "./type";

export default class Api {
  /** ai模型对话 */
  static chatphage = (data: type.Chatphage) =>
    request({ url: "/chatphage", method: "post", data });
}
